import { render, staticRenderFns } from "./MidwifeOverview.vue?vue&type=template&id=faad4280"
import script from "./MidwifeOverview.vue?vue&type=script&lang=js"
export * from "./MidwifeOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports